import React from 'react';

import ENUMS from '../../enums';
import { permissionHelper } from '../../utils';

const { REPLY_COMMENT_BY_RSEE_USER, REPLY_COMMENT_BY_CAFE_USER } = ENUMS.PERMISSIONS.values;

const CommentReplyButton = props => {

  const isRseeUserAllowedToRespond =
    props.status === 'CONFIRMED' &&
    permissionHelper.hasUserPermission(REPLY_COMMENT_BY_RSEE_USER) &&
    props.canReplyByRseeUser === true;

  const isCafeUserAllowedToRespond =
    props.status === 'CONFIRMED' &&
    permissionHelper.hasUserPermission(REPLY_COMMENT_BY_CAFE_USER) &&
    props.canReplyByCafeUser === true;

  if (isCafeUserAllowedToRespond || isRseeUserAllowedToRespond) {
    const btnJsx = (
      <button onClick={props.openReplyModal} className="btn btn-primary">
        {locales('titles.reply')}
      </button>
    );

    return btnJsx;
  }

  return null;
};

export default CommentReplyButton;
